import * as cacheIndexes from "./cacheIndexes";

export default cacheIndexes;
